import React from 'react';

import PdfDocument16Icon from '@atlaskit/icon-file-type/glyph/pdf-document/16';
import ExcelSpreadsheet16Icon from '@atlaskit/icon-file-type/glyph/excel-spreadsheet/16';
import WordDocument16Icon from '@atlaskit/icon-file-type/glyph/word-document/16';
import Audio16Icon from '@atlaskit/icon-file-type/glyph/audio/16';
import Video16Icon from '@atlaskit/icon-file-type/glyph/video/16';
import Generic16Icon from '@atlaskit/icon-file-type/glyph/generic/16';
import Folder16Icon from '@atlaskit/icon-file-type/glyph/folder/16';
import Gif16Icon from '@atlaskit/icon-file-type/glyph/gif/16';
import Sketch16Icon from '@atlaskit/icon-file-type/glyph/sketch/16';
import PowerpointPresentation16Icon from '@atlaskit/icon-file-type/glyph/powerpoint-presentation/16';
import Archive16Icon from '@atlaskit/icon-file-type/glyph/archive/16';
import Image16Icon from '@atlaskit/icon-file-type/glyph/image/16';
import SourceCode16Icon from '@atlaskit/icon-file-type/glyph/source-code/16';
import Executable16Icon from '@atlaskit/icon-file-type/glyph/executable/16';

import PdfDocument24Icon from '@atlaskit/icon-file-type/glyph/pdf-document/24';
import ExcelSpreadsheet24Icon from '@atlaskit/icon-file-type/glyph/excel-spreadsheet/24';
import WordDocument24Icon from '@atlaskit/icon-file-type/glyph/word-document/24';
import Audio24Icon from '@atlaskit/icon-file-type/glyph/audio/24';
import Video24Icon from '@atlaskit/icon-file-type/glyph/video/24';
import Generic24Icon from '@atlaskit/icon-file-type/glyph/generic/24';
import Folder24Icon from '@atlaskit/icon-file-type/glyph/folder/24';
import Gif24Icon from '@atlaskit/icon-file-type/glyph/gif/24';
import Sketch24Icon from '@atlaskit/icon-file-type/glyph/sketch/24';
import PowerpointPresentation24Icon from '@atlaskit/icon-file-type/glyph/powerpoint-presentation/24';
import Archive24Icon from '@atlaskit/icon-file-type/glyph/archive/24';
import Image24Icon from '@atlaskit/icon-file-type/glyph/image/24';
import SourceCode24Icon from '@atlaskit/icon-file-type/glyph/source-code/24';
import Executable24Icon from '@atlaskit/icon-file-type/glyph/executable/24';

import PdfDocument48Icon from '@atlaskit/icon-file-type/glyph/pdf-document/48';
import ExcelSpreadsheet48Icon from '@atlaskit/icon-file-type/glyph/excel-spreadsheet/48';
import WordDocument48Icon from '@atlaskit/icon-file-type/glyph/word-document/48';
import Audio48Icon from '@atlaskit/icon-file-type/glyph/audio/48';
import Video48Icon from '@atlaskit/icon-file-type/glyph/video/48';
import Generic48Icon from '@atlaskit/icon-file-type/glyph/generic/48';
import Folder48Icon from '@atlaskit/icon-file-type/glyph/folder/48';
import Gif48Icon from '@atlaskit/icon-file-type/glyph/gif/48';
import Sketch48Icon from '@atlaskit/icon-file-type/glyph/sketch/48';
import PowerpointPresentation48Icon from '@atlaskit/icon-file-type/glyph/powerpoint-presentation/48';
import Archive48Icon from '@atlaskit/icon-file-type/glyph/archive/48';
import Image48Icon from '@atlaskit/icon-file-type/glyph/image/48';
import SourceCode48Icon from '@atlaskit/icon-file-type/glyph/source-code/48';
import Executable48Icon from '@atlaskit/icon-file-type/glyph/executable/48';

const iconMapping = {
    PdfDocument: size => {
        switch(size) {
            case 16:
                return (
                   <PdfDocument16Icon /> 
                )
            case 24:
                return (
                    <PdfDocument24Icon /> 
                )
            case 48:
                return (
                    <PdfDocument48Icon /> 
                )
        }
    },
    ExcelSpreadsheet: size => {
        switch(size) {
            case 16:
                return (
                   <ExcelSpreadsheet16Icon /> 
                )
            case 24:
                return (
                    <ExcelSpreadsheet24Icon /> 
                )
            case 48:
                return (
                    <ExcelSpreadsheet48Icon /> 
                )
        }
    },
    WordDocument: size => {
        switch(size) {
            case 16:
                return (
                   <WordDocument16Icon /> 
                )
            case 24:
                return (
                    <WordDocument24Icon /> 
                )
            case 48:
                return (
                    <WordDocument48Icon /> 
                )
        }
    },
    Audio: size => {
        switch(size) {
            case 16:
                return (
                   <Audio16Icon /> 
                )
            case 24:
                return (
                    <Audio24Icon /> 
                )
            case 48:
                return (
                    <Audio48Icon /> 
                )
        }
    },
    Video: size => {
        switch(size) {
            case 16:
                return (
                   <Video16Icon /> 
                )
            case 24:
                return (
                    <Video24Icon /> 
                )
            case 48:
                return (
                    <Video48Icon /> 
                )
        }
    },
    Generic: size => {
        switch(size) {
            case 16:
                return (
                   <Generic16Icon /> 
                )
            case 24:
                return (
                    <Generic24Icon /> 
                )
            case 48:
                return (
                    <Generic48Icon /> 
                )
        }
    },
    Folder: size => {
        switch(size) {
            case 16:
                return (
                   <Folder16Icon /> 
                )
            case 24:
                return (
                    <Folder24Icon /> 
                )
            case 48:
                return (
                    <Folder48Icon /> 
                )
        }
    },
    Gif: size => {
        switch(size) {
            case 16:
                return (
                   <Gif16Icon /> 
                )
            case 24:
                return (
                    <Gif24Icon /> 
                )
            case 48:
                return (
                    <Gif48Icon /> 
                )
        }
    },
    Sketch: size => {
        switch(size) {
            case 16:
                return (
                   <Sketch16Icon /> 
                )
            case 24:
                return (
                    <Sketch24Icon /> 
                )
            case 48:
                return (
                    <Sketch48Icon /> 
                )
        }
    },
    PowerpointPresentation: size => {
        switch(size) {
            case 16:
                return (
                   <PowerpointPresentation16Icon /> 
                )
            case 24:
                return (
                    <PowerpointPresentation24Icon /> 
                )
            case 48:
                return (
                    <PowerpointPresentation48Icon /> 
                )
        }
    },
    Archive: size => {
        switch(size) {
            case 16:
                return (
                   <Archive16Icon /> 
                )
            case 24:
                return (
                    <Archive24Icon /> 
                )
            case 48:
                return (
                    <Archive48Icon /> 
                )
        }
    },
    Image: size => {
        switch(size) {
            case 16:
                return (
                   <Image16Icon /> 
                )
            case 24:
                return (
                    <Image24Icon /> 
                )
            case 48:
                return (
                    <Image48Icon /> 
                )
        }
    },
    SourceCode: size => {
        switch(size) {
            case 16:
                return (
                   <SourceCode16Icon /> 
                )
            case 24:
                return (
                    <SourceCode24Icon /> 
                )
            case 48:
                return (
                    <SourceCode48Icon /> 
                )
        }
    },
    Executable: size => {
        switch(size) {
            case 16:
                return (
                   <Executable16Icon /> 
                )
            case 24:
                return (
                    <Executable24Icon /> 
                )
            case 48:
                return (
                    <Executable48Icon /> 
                )
        }
    }
}

export default iconMapping;